module.exports = __webpack_public_path__ + "img/go-top.b5019897.png";